/*
 * Willdesk support bubble helpers. The widget is an app embed, so this runs
 * on top of its DOM.
 *  1. Adds a small "x" so visitors can hide the bubble for the current page
 *     view only. Nothing is stored: a refresh or the next page brings it back.
 *  2. Fades the bubble out while the cart drawer is open (it covers the cart
 *     totals otherwise) and back in when the drawer closes.
 * Checkout is not handled here: Shopify checkout pages do not run theme code.
 */
(function () {
  var CLS = 'loops-support-dismissed';
  var root = document.documentElement;

  function addClose() {
    var host = document.querySelector('#__helpdesk-channel .helpdesk-channel-btn-show');
    if (!host || host.querySelector('.loops-support-close')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'loops-support-close';
    btn.setAttribute('aria-label', 'Hide support button');
    btn.textContent = '×';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      root.classList.add(CLS);
    });
    host.appendChild(btn);
  }

  // Cart drawer: Alpine toggles an inline "display: none" on #CartContainer.
  var HIDE = 'loops-support-hidden';
  function watchCart() {
    var cart = document.getElementById('CartContainer');
    if (!cart) return;
    function sync() {
      root.classList.toggle(HIDE, cart.style.display !== 'none');
    }
    sync();
    new MutationObserver(sync).observe(cart, { attributes: true, attributeFilter: ['style'] });
  }

  function start() {
    addClose();
    watchCart();
    // The widget renders late and re-renders its button; keep the "x" attached.
    new MutationObserver(addClose).observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
